/**
 * Filters out elements from `listA` that have a matching `key` value in `listB`.
 *
 * @param listA - The array to be filtered.
 * @param listB - The array containing elements to filter out from `listA`.
 * @param key - The key to compare between elements of `listA` and `listB`.
 * @returns A new array containing elements from `listA` that do not have a matching `key` value in `listB`.
 */
export const getFilteredList = (listA: any[], listB: any[], key: string) => {
  const idsInB = new Set(listB.map((item) => item[key]));
  return listA.filter((item) => !idsInB.has(item[key]));
};

export const sortByDisplayName = <T extends Record<string, any>>(
  list: T[] | null | undefined,
  field = "name",
) =>
  [...(list || [])].sort((a, b) =>
    String(a?.[field] ?? "").localeCompare(String(b?.[field] ?? ""), undefined, {
      sensitivity: "base",
      numeric: true,
    }),
  );

export const removeDuplicatedElements = (list: any[], key: string) => {
  const set = new Set();
  return list.filter((item) => {
    if (set.has(item[key])) {
      return false;
    }
    set.add(item[key]);
    return true;
  });
};
